import { colorList } from "utils/colors";
import HelperPlatform from "utils/helper-platform";
import _ from 'lodash'
import Color from 'color';

const rgba = (color, opacity) => {
	return Color(color).alpha(opacity);
};

export const shadow = ({ color, opacity, radius, offsetWidth, offsetHeight, elevation, backgroundColor = 'transparent' }) => {
	return HelperPlatform.select({
		ios: {
			shadowColor: color,
			shadowOpacity: opacity,
			shadowRadius: radius,
			shadowOffset: {
				width: offsetWidth,
				height: offsetHeight,
			}
		},
		android: {
			elevation,
			borderRadius: radius,
			//backgroundColor: 'white',
			backgroundColor: backgroundColor,
		},
		web: {
			boxShadow: `${offsetWidth}px ${offsetHeight}px ${radius}px ${rgba( color, opacity )}`
		}
	});
};

const padding = ( amount ) => {
	return HelperPlatform.select({
		web: {
			padding: `${amount}px`,
			paddingVertical: `${amount}px`,
			paddingHorizontal: `${amount}px`,
		},
		default: {
			padding: amount,
			paddingVertical: amount,
			paddingHorizontal: amount
		}
	});
}

const margin = ( amount ) => {
	return HelperPlatform.select({
		web: {
			margin: `${amount}px`,
			marginVertical: `${amount}px`,
			marginHorizontal: `${amount}px`,
		},
		default: {
			margin: amount,
			marginVertical: amount,
			marginHorizontal: amount
		}
	});
}

export const ThemedValues = {
	borderRadius: HelperPlatform.select({
		native: 8,
		default: '8px'
	}),
	marginVertical: HelperPlatform.select({
		native: 16,
		default: '16px'
	}),
	marginHorizontal: HelperPlatform.select({
		native: 8,
		default: '8px'
	}),
	
	stackSpace: 12
};

export const ThemedFontSizes = {
	default: {
		fontSize: 15,
	},
}

export const ThemedFonts = {
	bold: {
        fontFamily: 'OpenSans-Bold',
    },
    semiBold: {
        fontFamily: 'OpenSans-SemiBold',
    },
    light: {
        fontFamily: 'OpenSans-Light',
    },
    regular: {
        fontFamily: 'OpenSans-Regular',
    },
}

export const ThemedValuesWeb = {
	layoutPadding: '30px',
}

export const ThemedSizes = {
	XXS: 'xxs',
	XS: 'xs',
	S: 's',
	M: 'm',
	L: 'l',
	XL: 'xl'
}

export const ThemedShared = {
	textHint: {
		color: colorList.TEXT_HINT.primary
	},
	textWhite: {
		color: colorList.WHITE.primary
	},
	textPrimary: {
		color: colorList.PRIMARY.primary
	},
	textPrimaryDark: {
		color: colorList.PRIMARY.dark
	},
	textPrimaryLight: {
		color: colorList.PRIMARY.light
	},

	textSizeSmall: {
		fontSize: 10
	},
	textSizeMedium: {
		fontSize: 15
	},
	textSizeLarge: {
		fontSize: 25
	},
	textSizeExtraLarge: {
		fontSize: 36
	},

	textShadowed: {
		textShadowColor: 'rgba(0, 0, 0, 0.75)',
		textShadowOffset: {
			width: -1,
			height: 1
		},
		textShadowRadius: 10
	},
	
	shadowed: {
		overflow: 'visible',
		...shadow({
			elevation: 3,
			color: '#000',
			opacity: 0.12,
			radius: 5.46,
			offsetWidth: 0,
			offsetHeight: 4
		}),
	},
	
	bordered: {
		borderRadius: ThemedValues.borderRadius,
		borderWidth: 1,
		borderColor: colorList.GREY.dark
	},
	
	backdrop: {
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},

	paddingSmall: {
		...padding( 8 )
	},
	paddingMedium: {
		...padding( 16 )
	},
	paddingLarge: {
		...padding( 32 )
	},
	paddingExtraLarge: {
		...padding( 64 )
	},

	negativeMarginSmall: {
		...margin( -8 )
	},
	negativeMarginMedium: {
		...margin( -16 )
	},
	negativeMarginLarge: {
		...margin( -32 )
	},
	negativeMarginExtraLarge: {
		...margin( -64 )
	},

	borderRadius: {
		borderRadius: ThemedValues.borderRadius
	},
};

export const ThemedBlockStyles = {
	container: {
		justifyContent: 'center',
		borderRadius: ThemedValues.borderRadius,
		overflow: 'hidden',
		backgroundColor: colorList.WHITE.primary,
	},

	header: {
		overflow: 'hidden',
		flex: 1,
		width: 'auto',
		flexDirection:'column',
		justifyContent: 'flex-end',
		alignItems: 'flex-start',
		backgroundColor: colorList.DIVIDER.light,
		borderBottomWidth: 2,
		borderBottomColor: colorList.DIVIDER.primary,
		padding: ThemedShared.paddingSmall.padding,
		marginBottom: 0,
	},
	
	headerColumn: {
		width: 'auto',
		alignContent: 'center',
		justifyContent: 'center'
	},
	
	footerHeaderContainer: {
		overflow: 'hidden',
		borderBottomWidth: 2,
	},
	
	headerContainer: {
		borderTopLeftRadius: ThemedValues.borderRadius,
		borderTopRightRadius: ThemedValues.borderRadius,
		backgroundColor: colorList.GREY.light,
		borderBottomColor: colorList.GREY.primary,
	},
	footerContainer: {
		backgroundColor: colorList.GREY.light,
		borderTopColor: colorList.GREY.primary,
	},
};

export const ThemedBlockTitleStyles = {
	text: {
		opacity: 1,
		fontWeight: "700",
		...HelperPlatform.select({
			native: {
				marginBottom: 8,
			},
			web: {
				marginBottom: '8px',
			}
		}),
	},
};

export const createStyles = ( styles, props ) => {
	styles = !_.isArray( styles ) ? [ styles ] : styles;
	
	let propStyle = _.get( props, 'style', {} );
	if( !_.isEmpty( propStyle ) ) {
		if( !_.isArray( propStyle ) ) {
			propStyle = [ propStyle ]
		}
		
		propStyle.map( i => {
			return styles.push(i);
		} )
	}
	
	return styles
}
